module.exports = __webpack_public_path__ + "static/media/shiftshave-replacement-blade-4.126865c0.png";